/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  hidePinForm,
  showPinForm,
} from 'containers/PinForm/actions/pinForm.actions';

import { Form } from 'cvlib';

import './DecideNewPin.scss';

const DecideNewPin = props => {
  const dispatch = useDispatch();
  const pinForm = useSelector(state => state.PinForm);
  const translations = useSelector(state => state.translations);
  const translate = key =>
    translations[key] !== undefined ? translations[key] : key;
  const {
    onNextClicked = () =>
      dispatch(
        showPinForm({
          ...pinForm,
          type: 'CREATE_NEW_PIN',
          title: translate('setupPin_modal_instruction_label'),
        }),
      ),
    onCancelClicked = () => dispatch(hidePinForm()),
  } = props;

  const elements = [
    {
      element: 'title',
      content: translate('setupPin_confirmation_title_label'),
      className: 'decide-pin__title',
    },
    {
      element: 'subtitle',
      content: translate('setupPin_confirmation_detail_label'),
      className: 'decide-pin__description',
    },
    {
      element: 'button',
      type: 'red',
      content: translate('setupPin_confirmation_option_button_configure'),
      submit: onNextClicked,
      position: 'bottom',
      className: 'decide-pin__redButton',
    },
    {
      element: 'button',
      type: 'gray',
      content: translate('setupPin_confirmation_option_button_cancel'),
      onClick: onCancelClicked,
      position: 'bottom',
      className: 'decide-pin__grayButton',
    },
  ];

  return (
    <Form elements={elements} classes={['configure-pin-confirmation-modal']} />
  );
};

DecideNewPin.propTypes = {
  onCancelClicked: PropTypes.func.isRequired,
  onNextClicked: PropTypes.func.isRequired,
};

// DecideNewPin.defaultProps = {
//   title: 'Ingresa tu PIN de seguridad para bloquar este canal',
// };

export default DecideNewPin;
